"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavWrapper = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const SideNav_1 = require("@episource/epi-storybook/lib/components/SideNav");
const components_1 = require("../../../components");
const AppBarWrapper_1 = require("../AppBarWrapper");
const NavWrapperRoot = (0, material_1.styled)("div")({
    display: "flex",
});
const NavWrapperContent = (0, material_1.styled)("div")({
    width: "calc(100% - 100px)",
    marginTop: 15,
    marginLeft: 20,
});
const NavWrapper = ({ navItems, navElements, selectedBusinessLineState, primaryNavName, children, lastUpdatedDate, lastUpdatedMmrDate, lastUpdatedMorDate, currentYear, client, ...props }) => {
    const appBarRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AppBarWrapper_1.AppBarWrapper, { ref: appBarRef, primaryNavName: primaryNavName, navItems: navItems, client: client, ...props }),
        client ? (react_1.default.createElement(NavWrapperRoot, null,
            react_1.default.createElement(SideNav_1.SideNavVersion2, { appBarRef: appBarRef },
                navElements,
                react_1.default.createElement(components_1.LastLoadDateTable, { lastUpdatedDate: lastUpdatedDate, lastUpdatedMmrDate: lastUpdatedMmrDate, lastUpdatedMorDate: lastUpdatedMorDate, currentYear: currentYear, state: selectedBusinessLineState || "" })),
            react_1.default.createElement(NavWrapperContent, null, children))) : (react_1.default.createElement(components_1.CentralizedLoading, null))));
};
exports.NavWrapper = NavWrapper;
exports.default = exports.NavWrapper;
